import React, { FC } from 'react';
import styled from 'styled-components';

interface SwitchProps {
    name: string;
    value: boolean;
    // eslint-disable-next-line no-unused-vars
    onChange: (value: boolean, name: string | undefined) => void;
    disabled?: boolean;
}

const Switch: FC<SwitchProps> = ({ name, value = false, onChange, disabled = false }) => {
    const handleChange = () => {
        if (disabled) return;

        onChange(!value, name);
    };

    return (
        <CheckBoxWrapper>
            <CheckBox
                id={`checkbox-${name}`}
                disabled={disabled}
                type="checkbox"
                name={name}
                checked={value}
                onChange={handleChange}
            />
            <CheckBoxLabel htmlFor={`checkbox-${name}`} checked={value} />
        </CheckBoxWrapper>
    );
};

const CheckBoxWrapper = styled.div`
    position: relative;
    width: 28px;
    height: 14px;
`;

const CheckBox = styled.input<{ disabled: boolean }>`
    ${({ disabled }) => `
           opacity: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    position: absolute;
    z-index: 1;
    cursor: ${disabled ? 'not-allowed' : 'pointer'};
    `}
`;

const CheckBoxLabel = styled.label<{ checked: boolean }>`
    ${({ theme: { colors }, checked }) => `
        display: block;
        width: 100%;
        height: 100%;
        border-radius: 20px;
        background: ${checked ? colors.text.primary : colors.border.dark};
        position: relative;
        cursor: pointer;
        transition: background 0.2s;
        &::after {
            content: '';
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: ${checked ? '16px' : '1px'};
            width: 11px;
            height: 11px;
            border-radius: 50%;
            background: ${colors.text.primaryReverse};
            transition: left 0.2s;
        }
    `}
`;

export { Switch };
